import { isBlobURL } from "../../dom";
import { getBlockProps } from "../blocks-parser";

const imageSingleSchema = {
  img: {
    attributes: ["src", "alt", "title"],
    classes: [
      "alignleft",
      "aligncenter",
      "alignright",
      "alignnone",
      /^grigora-image-\d+$/,
    ],
  },
};

const props = {
  align: {
    type: "string",
  },
  src: {
    type: "string",
    source: "attribute",
    selector: "img",
    attribute: "src",
  },
  srcMode: {
    type: "string",
    default: "link",
  },
  altText: {
    type: "string",
    source: "attribute",
    selector: "img",
    attribute: "alt",
    default: "",
  },
  caption: {
    type: "string",
    source: "html",
    selector: "figcaption",
  },
  titleText: {
    type: "string",
    source: "attribute",
    selector: "img",
    attribute: "title",
  },
  imageLink: {
    type: "string",
    source: "attribute",
    selector: "figure > a",
    attribute: "href",
  },
  width: {
    type: "number",
  },
  height: {
    type: "number",
  },
};

const imageSchema = {
  blockSlug: "grigora/image",
  isMatch: (node) => node.nodeName === "FIGURE" && !!node.querySelector("img"),
  schema: ({ phrasingContentSchema }) => ({
    figure: {
      require: ["img"],
      children: {
        ...imageSingleSchema,
        a: {
          attributes: ["href", "rel", "target"],
          children: imageSingleSchema,
        },
        figcaption: {
          children: phrasingContentSchema,
        },
      },
    },
  }),
  transform: (node) => {
    // Search both figure and image classes. Alignment could be
    // set on either. ID is set on the image.
    const className =
      node.className + " " + node.querySelector("img").className;
    const alignMatches = /(?:^|\s)align(left|center|right)(?:$|\s)/.exec(
      className,
    );
    const anchor = node.id === "" ? undefined : node.id;
    const align = alignMatches ? alignMatches[1] : undefined;
    const idMatches = /(?:^|\s)wp-image-(\d+)(?:$|\s)/.exec(className);
    const id = idMatches ? Number(idMatches[1]) : undefined;
    const anchorElement = node.querySelector("a");
    const linkDestination =
      anchorElement && anchorElement.href ? "custom" : undefined;
    const href =
      anchorElement && anchorElement.href ? anchorElement.href : undefined;
    const rel =
      anchorElement && anchorElement.rel ? anchorElement.rel : undefined;
    const linkClass =
      anchorElement && anchorElement.className
        ? anchorElement.className
        : undefined;

    var blockProps = getBlockProps("grigora/image", node.outerHTML, props);

    blockProps = {
      ...blockProps,
      srcMode: "link",
    };

    if (blockProps.src && isBlobURL(blockProps.src)) {
      blockProps = {
        ...blockProps,
        srcMode: "link",
        srcActionTrigger: "upload",
      };
    }
    return {
      blockSlug: "grigora/image",
      blockProps: blockProps,
    };
  },
};

export { imageSchema };
